import { defineStore } from 'pinia';
import { ref } from 'vue';
import { api } from '@/lib/api';
export const useContextStore=defineStore('context',()=>{
  const year=ref(2026),odei=ref('Lima'),type=ref('Campo'),month=ref('');
  const years=ref([2026,2025]),odeis=ref(['Lima','Arequipa','Cusco']),types=ref(['Campo','Oficina']);
  let loaded=false;
  let pending:Promise<void>|undefined;
  async function load(){
    if(loaded)return;
    if(pending)return pending;
    pending=(async()=>{
      const value=await api<{years:number[];odeis:string[];types:string[]}>('/context');
      years.value=value.years;odeis.value=value.odeis;types.value=value.types;loaded=true;
    })().finally(()=>{pending=undefined;});
    return pending;
  }
  return {year,odei,type,month,years,odeis,types,load};
});
